import { useMemo } from 'react';
import { ScheduleStore } from '../../../stores/ScheduleStore';

/**
 * Hook for managing calendar mode in Home component
 */
export const useHomeCalendarMode = (
  isDayDetail: boolean,
  calendarCurrentDate: Date,
  scheduleStore: ScheduleStore
) => {
  const calendarData = useMemo(() => {
    if (isDayDetail) {
      return null;
    }

    const currentSchedule =
      scheduleStore.getScheduleForDate(calendarCurrentDate);

    return {
      currentSchedule,
    };
  }, [isDayDetail, calendarCurrentDate, scheduleStore]);

  return calendarData;
};
